<script lang="ts">
	import arrowRightIcon from "@assets/icons/arrow_right_alt.svg?raw";
	import { getChromosomeSearchPath } from "@core/schema/paths/getChromosomeSearchPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import Formatted from "./common/Formatted.svelte";
	import Icon from "./common/Icon.svelte";
	import Link from "./common/Link.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const { tenant } = getGlobalTemplateProps();
</script>

<section class="bg-black full-width grid-container pt-12 pb-10 lg:pt-20 lg:pb-28">
	<div class="grid lg:grid-cols-2 gap-4 md:gap-24">
		<h2 class="max-lg:text-xl text-lightblue"><Formatted text="Vyhledejte produkt nl[[]]dle cw[[chromozomu]]" /></h2>
		<div class="flex flex-col gap-4">
			<p class="md:text-md text-lightwhite leading-relaxed md:leading-8">
				<Formatted
					text="Každý test FISH je navržen pro specifické chromozomální změny. Pomocí vyhledávání dle chromozomu snadno najdete sondy a reagencie odpovídající vašim potřebám v oblasti molekulární cytogenetiky."
				/>
			</p>
			<p class="text-lightblue font-bold text-md leading-8">
				<Formatted text="Vyberte správný test pro přesnou diagnostiku a výzkum." />
			</p>
			<Link
				class="lg:w-80 xl:w-96 flex items-center justify-center gap-1"
				variant={ButtonVariant.Primary}
				href={getChromosomeSearchPath(tenant, null)}
			>
				<span>Hledat dle chromozomu</span>
				<Icon icon={arrowRightIcon} class="w-3.5" />
			</Link>
		</div>
	</div>
</section>
